import styled from "@emotion/styled";
import { MAX_DESKTOP_CONTENT_WIDTH } from "constants/vp-sizes";
export const StyledWhatsNewPageLayoutDesktopComponent = styled.div`
  .whats-new-page-content {
    font-size: 54px;
    text-align: center;

    .items-list-wrapper {
      display: flex;
      margin-top: 40px;
      justify-content: center;
    }

    @media (max-width: ${MAX_DESKTOP_CONTENT_WIDTH}px) {
      .whats-new-apps-section-wrapper {
        display: none;
      }
    }
  }
`;
